import TrendChart from "./TrendChart";
import BarChartCard from "./BarChartCard";
import PieChartCard from "./PieChartCard";
import AreaChartCard from "./AreaChartCard";
import { chartData, chartPalette } from "../../data/chartData";
import type { ChartConfig } from "../../types/reports.types";

interface ChartRendererProps {
  chart?: ChartConfig;
}

export default function ChartRenderer({ chart }: ChartRendererProps) {
  if (!chart) return null;

  const data = chartData[chart.dataKey] ?? [];

  if (chart.kind === "pie") {
    return (
      <PieChartCard
        data={data}
        colors={
          chart.colors ?? [
            chartPalette.blue,
            chartPalette.blueLight,
            chartPalette.teal,
            chartPalette.green,
            chartPalette.amber,
            chartPalette.purple,
          ]
        }
      />
    );
  }

  if (chart.kind === "bar") {
    return (
      <BarChartCard
        data={data}
        bars={chart.bars}
        layout={chart.layout ?? "horizontal"}
      />
    );
  }

  if (chart.kind === "area") {
    return <AreaChartCard data={data} areas={chart.lines} />;
  }

  return <TrendChart data={data} lines={chart.lines} />;
}
